import React from 'react';
import { Controller } from 'react-hook-form';
import { Row, Col, Form } from 'react-bootstrap';

const PotenciasInput = ({ control, watch, errors, readOnly = false }) => {
    const regexpPotencia = /^[0-9]+,*([0-9])*$/;
    const potencias = watch("potencias") || {};

    // Orden natural P1..P6
    const keysOrdenadas = Object.keys(potencias)
        .sort((a, b) => parseInt(a.replace(/\D/g, ''), 10) - parseInt(b.replace(/\D/g, ''), 10));

    // Agrupar en filas de 3
    const filas = [];
    for (let i = 0; i < keysOrdenadas.length; i += 3) {
        filas.push(keysOrdenadas.slice(i, i + 3));
    }

    return (
        <div className="bg-light p-4 rounded-4 border border-light mb-4">
            <Row className="mb-3">
                <Col>
                    <h5 className="fw-bold text-secondary mb-0">Potencias (kW)</h5>
                </Col>
            </Row>

            {filas.map((fila, idxFila) => (
                <Row className="g-3 mb-3" key={`fila-${idxFila}`}>
                    {fila.map((potKey) => (
                        <Col key={potKey} md={12 / fila.length}>
                            <Form.Group>
                                <Form.Label className="text-muted small fw-bold text-uppercase">
                                    {potKey}
                                </Form.Label>
                                <Controller
                                    name={`potencias.${potKey}`}
                                    control={control}
                                    render={({ field }) => (
                                        <Form.Control
                                            {...field}
                                            size="md"
                                            className="form-control rounded-3 shadow-sm border-light bg-white"
                                            isInvalid={!!errors?.potencias?.[potKey]}
                                            placeholder="0"
                                            readOnly={readOnly}
                                            disabled={readOnly}
                                            onChange={(e) => {
                                                const value = e.target.value;
                                                if (value === "" || regexpPotencia.test(value)) field.onChange(value);
                                            }}
                                        />
                                    )}
                                />
                                {errors?.potencias?.[potKey]?.message && (
                                    <div className="text-danger small mt-1 fw-bold">
                                        {errors.potencias[potKey].message}
                                    </div>
                                )}
                            </Form.Group>
                        </Col>
                    ))}
                </Row>
            ))}
        </div>
    );
};

export default PotenciasInput;
